class CoveSortControl extends HTMLElement {
  connectedCallback() {
    if (this.dataset.coveSortReady === 'true') return;
    this.dataset.coveSortReady = 'true';

    this.nativeSelect = this.querySelector('.cove-sort-control__native');
    this.wrapper = this.querySelector('.cove-sort-control__details');
    this.trigger = this.querySelector('[data-cove-sort-trigger]');
    this.menu = this.querySelector('[data-cove-sort-menu]');
    this.currentLabel = this.querySelector('[data-cove-sort-current]');
    this.options = Array.from(this.querySelectorAll('[data-cove-sort-value]'));

    this.boundToggle = this.toggleMenu.bind(this);
    this.boundDocumentClick = this.onDocumentClick.bind(this);
    this.boundKeyDown = this.onKeyDown.bind(this);

    if (!this.nativeSelect || !this.wrapper || !this.trigger || !this.menu || !this.options.length) return;

    this.trigger.addEventListener('click', this.boundToggle);
    this.options.forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.selectOption(option);
      });
    });

    this.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('click', this.boundDocumentClick);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.boundToggle);
    this.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('click', this.boundDocumentClick);
  }

  get isOpen() {
    return this.wrapper?.classList.contains('is-open');
  }

  toggleMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    this.isOpen ? this.closeMenu() : this.openMenu();
  }

  openMenu() {
    document.querySelectorAll('cove-sort-control').forEach((control) => {
      if (control !== this && typeof control.closeMenu === 'function') control.closeMenu();
    });

    this.wrapper.classList.add('is-open');
    this.menu.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  closeMenu({ restoreFocus = false } = {}) {
    if (!this.wrapper || !this.menu || !this.trigger) return;
    this.wrapper.classList.remove('is-open');
    this.menu.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
    if (restoreFocus) this.trigger.focus();
  }

  selectOption(option) {
    const value = option.dataset.coveSortValue;
    if (!value) return;

    CoveSortControl.syncAll(value);
    this.closeMenu();

    // Dawn's facet engine listens for a bubbling input event and refreshes the
    // product grid without a full page reload.
    this.nativeSelect.dispatchEvent(new Event('input', { bubbles: true }));
  }

  static syncAll(value) {
    document.querySelectorAll('cove-sort-control').forEach((control) => {
      const nativeSelect = control.querySelector('.cove-sort-control__native');
      const currentLabel = control.querySelector('[data-cove-sort-current]');
      const options = Array.from(control.querySelectorAll('[data-cove-sort-value]'));
      const selected = options.find((item) => item.dataset.coveSortValue === value);

      if (nativeSelect) nativeSelect.value = value;
      if (selected && currentLabel) {
        currentLabel.textContent = selected.querySelector('span')?.textContent?.trim() || selected.textContent.trim();
      }

      options.forEach((item) => {
        const isSelected = item.dataset.coveSortValue === value;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    });
  }

  onKeyDown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      event.preventDefault();
      event.stopPropagation();
      this.closeMenu({ restoreFocus: true });
    }
  }

  onDocumentClick(event) {
    if (this.isOpen && !this.contains(event.target)) this.closeMenu();
  }
}

if (!customElements.get('cove-sort-control')) {
  customElements.define('cove-sort-control', CoveSortControl);
}
